<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">
          <div class="card-body table">
            <div class="toolbar-container px-3">
              <div class="toolbar-row d-flex align-items-center justify-content-between mb-2">
                <PageHeader :title="title" :items="items" class="poppins fw-normal ps-0 text-nowrap" />
                <div class="d-flex gap-2 flex-wrap p-0 buttons-container">
                  <CustomButton 
                    :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'"
                    :loading = "downloadReportProcessing"
                    class="p-0"
                    @click="downloadReport" 
                  />
                </div>
              </div>

              <div class="toolbar-row d-flex gap-2 align-items-center">
                <searchInput @getSearched="handleSearch" class="p-0" />
                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0" />    
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-xl-8 col-8">

                <div class="d-flex align-items-sm-center align-items-start gap-lg-3 gap-2 flex-column flex-sm-row">
                  <PageHeader title="Reviews Listing" class="poppins fw-normal text-nowrap ps-3" />

                  <searchInput @getSearched="handleSearch" class="w-100" />
                  <pageSize @getPageSize="handlePageSize" class="w-100" />

                </div>       -->
                      <!-- <div :class="{
               'del_btn-wrapper': true,
                'border-orange rounded-pill p1': multipuleIds.length >= 1
                    }">
                <button
                  v-if="multipuleIds.length >= 1"
                  @click="deleteBulk"
                  class="btn border-0 px-5 fw-bold text-white btn btn-primary waves-effect waves-light w-md primary-button rounded-pill"
                >
                  Delete All
                </button>
              </div> -->
            <!-- </div>
              <div class="col-xl-4 col-4">
                <div class="d-flex justify-content-end gap-2 mt-2 mt-xl-0 ms-auto">
                  <div class="add_new border-orange rounded-pill p1">
                    <button @click="downloadReport"
                      class="btn btn-primary border-0 px-4 fw-bold text-white waves-effect waves-light w-md primary-button rounded-pill"
                      :disabled="downloadReportProcessing">
                      {{ downloadReportProcessing ? 'Please wait...' : 'Download Report' }}
                    </button>
                  </div>
                </div>
              </div>
            </div> -->
            <b-modal
              ref="review-modal"
              hide-footer
              title="Review Details"
              size="xl"
            >
              <div v-if="loading" class="text-center">
                <APILoader :loading="loading" />
              </div>
              <div v-else-if="selectedReview" class="review-info">
                <div class="review-column">
                  <h6 class="mb-3">Review</h6>

                  <p><strong>User:</strong>
                    {{
                      selectedReview.user
                        ? (selectedReview.user.full_name
                          || [selectedReview.user.first_name, selectedReview.user.last_name].filter(Boolean).join(" "))
                        : "N/A"
                    }}
                  </p>

                  <p><strong>User email:</strong>
                    {{ selectedReview.user ? selectedReview.user.email : "N/A" }}
                  </p>

                  <p><strong>Rating:</strong> {{ selectedReview.star ?? "N/A" }}</p>

                  <p><strong>Created at:</strong>
                    {{ selectedReview.created_at ? new Date(selectedReview.created_at).toLocaleString() : "N/A" }}
                  </p>

                  <p class="mt-3">
                    <strong>Message:</strong><br />
                    {{ selectedReview.message ?? "No review message found" }}
                  </p>
                </div>
                <div class="review-column">
                  <h6 class="mb-3">Restaurant Details</h6>

                  <p><strong>Name:</strong>
                    {{
                      selectedReview.commentable && selectedReview.commentable.title
                        ? selectedReview.commentable.title
                        : "N/A"
                    }}
                  </p>

                  <p><strong>Slug:</strong>
                    {{
                      selectedReview.commentable && selectedReview.commentable.slug
                        ? selectedReview.commentable.slug
                        : "N/A"
                    }}
                  </p>

                  <p><strong>Price range:</strong>
                    {{
                      selectedReview.commentable && selectedReview.commentable.price_range
                        ? selectedReview.commentable.price_range
                        : "N/A"
                    }}
                  </p>

                  <p><strong>Website:</strong>
                    <span v-if="selectedReview.commentable && selectedReview.commentable.website">
                      <a
                        :href="selectedReview.commentable.website"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ selectedReview.commentable.website }}
                      </a>
                    </span>
                    <span v-else>N/A</span>
                  </p>

                  <p v-if="selectedReview.commentable && selectedReview.commentable.address">
                    <strong>Address:</strong>
                    {{
                      selectedReview.commentable.address.address || ""
                    }}
                    <span v-if="selectedReview.commentable.address.city">
                      , {{ selectedReview.commentable.address.city }}
                    </span>
                    <span v-if="selectedReview.commentable.address.state">
                      , {{ selectedReview.commentable.address.state }}
                    </span>
                    <span v-if="selectedReview.commentable.address.country">
                      , {{ selectedReview.commentable.address.country }}
                    </span>
                  </p>
                  <p>
                    <strong>Location types:</strong>
                    <span
                      v-if="selectedReview.commentable
                        && selectedReview.commentable.location_types
                        && selectedReview.commentable.location_types.length"
                    >
                      {{ selectedReview.commentable.location_types.map(t => t.title).join(", ") }}
                    </span>
                    <span v-else>N/A</span>
                  </p>

                  <p>
                    <strong>Location categories:</strong>
                    <span
                      v-if="selectedReview.commentable
                        && selectedReview.commentable.location_categories
                        && selectedReview.commentable.location_categories.length"
                    >
                      {{ selectedReview.commentable.location_categories.map(c => c.title).join(", ") }}
                    </span>
                    <span v-else>N/A</span>
                  </p>
                </div>
              </div>

              <div v-else>
                No review data found.
              </div>
            </b-modal>
            <!-- end table-responsive -->
            <GeneralTable :isProcessing="processing" :items="reviews" :fields="fields" :showEyeButton="true" @showItem="showDescription"
              :showActionButton="false"></GeneralTable>
            <Pagination @paginator="allReviews" :pagination="paginatelinks" :showing="paginate"
              @page-changed="handlePageChange" />
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import Swal from "sweetalert2";
import GeneralTable from "../../../../components/MagicTable/GeneralTable.vue";
import searchInput from "../../../../components/general/searchInput.vue";
import Pagination from "../../../../components/general/pagination.vue";
import pageSize from "../../../../components/general/pageSize.vue";
import CustomButton from "../../../../components/CustomButton.vue";
export default {
  name: "sub-category",
  components: {
    Layout,
    PageHeader,
    GeneralTable,
    searchInput,
    pageSize,
    Pagination,
    CustomButton
  },
  data() {
    return {
      currentPageNumber: null,
      fields: [
        { key: 'select', label: 'Select', sortable: false, },
        { key: 'id' },
        { key: 'commentable_name', label: 'Restaurant Name' },
        { key: 'avatar_with_title', label: 'User Name'},
        { key: 'message', label: 'Message' },
        { key: 'star', label: 'Rating' },
        { key: 'created_at', tdClass: 'align-middle' },
        { key: 'action', tdClass: 'align-middle' },
      ],
      multipuleIds: [],
      reviewByPerson: null,
      selectAll: false,
      selectedReview: null,
      title: "Reviews",
      loading: true,
      reviews: [],
      processing: false,
      paginate: {},
      paginatelinks: [],
      pageSize: 10,
      downloadReportProcessing: false,
    };
  },
  mounted() {
    let url = null;
    if (this.$route.query.currentPage) {
      url = process.env.VUE_APP_BASEURL + '/reviews?page=' + this.$route.query.currentPage;
    }
    this.allReviews({ url });
    this.processing = true;
  },
  computed: {
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.items.slice(start, start + this.itemsPerPage);
    }
  },
  methods: {
    showDescription(reviewId) {
      this.fetchDescription(reviewId);
    },
    fetchDescription(id) {
      this.loading = true;
      this.$axios
        .get(`reviews/${id}`)
        .then(response => {
          const review = response.data && response.data.data ? response.data.data : null;

          this.selectedReview = review;
          this.reviewByPerson = review ? review.message : null;

          console.log('Selected review in modal:', this.selectedReview);

          this.loading = false;
          this.openPopup();
        })
        .catch(error => {
          console.error('Error fetching review:', error);
          this.loading = false;
        });
    },
    openPopup() {
        this.$refs['review-modal'].show();
      },
      hideModal() {
          return this.$refs['review-modal'].hide();
      },
    handlePageChange(pageNumber) {
      if (pageNumber <= 0) {
        this.triggerSwal("Page not found. Please enter a valid page number.", "error");
        return;
      }

      const lastPageUrl = this.paginate?.last_page;
      let lastPage = 1;
      if (lastPageUrl) {
        const match = lastPageUrl.match(/page=(\d+)/);
        if (match && match[1]) {
          lastPage = parseInt(match[1], 10);
        }
      }

      if (pageNumber > lastPage) {
        this.triggerSwal("Page not found. Please enter a valid page number.", "error");
        return;
      }
      const baseUrl = "reviews";
      const pageUrl = `${baseUrl}?page=${pageNumber}`;
      this.allReviews({ url: pageUrl });
    },

    downloadReport() {
      if (!this.reviews || this.reviews.length === 0) {
        if (typeof this.triggerSwal === "function") {
          this.triggerSwal("No data available to download.", "warning");
        } else {
          alert("No data available to download.");
        }
        return;
      }

      this.downloadReportProcessing = true;

      const headers = [
        "ID",
        "Restaurant Name",
        "User Name",
        "Rating",
        "Message",
        "Created At",
      ];

      const rows = this.reviews.map((review) => [
        review.id,
        review.commentable_name || "",
        review.name || "",
        review.star ?? "",
        review.message || "",
        review.created_at || "",
      ]);

      let csvContent = "";
      csvContent += headers.join(",") + "\n";

      rows.forEach((row) => {
        csvContent +=
          row
            .map((value) =>
              `"${String(value ?? "")
                .replace(/"/g, '""')
                .replace(/\n/g, " ")}"`
            )
            .join(",") + "\n";
      });

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `reviews-report-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      this.downloadReportProcessing = false;
    },

    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 10;
      this.allReviews({ pageSize: this.pageSize });
    },
    randerData(response) {
      this.currentPageNumber = response.data.data.current_page;
      this.paginate = {
        first_page: response?.data?.data?.first_page_url,
        last_page: response?.data?.data?.last_page_url,
        links: response?.data?.data?.links,
        from: response?.data?.data?.from,
        to: response?.data?.data?.to,
        total: response?.data?.data?.total,
      }
      this.paginate.links = this.paginate?.links?.length > 0 ? this.paginate.links : []
      this.paginatelinks = this.paginate.links.map(item => ({
        url: item.url,
        label: item.label,
        active: item.active,
      }));

      let allReviews = Array.isArray(response?.data?.data?.data) && response?.data?.data?.data?.length > 0
        ? response.data.data.data
        : [];
      console.log(allReviews, "allllllll");
      this.reviews = allReviews.map(review => ({
      id: review.id,
      avatar: review?.user?.avatar,
      star: review.star,
      message: this.truncateMessage(review?.message),
      created_at: this.formatDate(review.created_at),
      name: review?.user?.full_name,
      commentable_name: review?.commentable?.title || "N/A",
    }));
console.log(this.reviews, "formatted locationTypes");

      this.processing = false;
    },
    allReviews({ url = null, searchItem = null, pageSize = this.pageSize } = {}) {
      let endPoint = "reviews";
      endPoint = url ? url : endPoint;
      this.$axios
        .get(endPoint, { params: { search: searchItem, page_size: pageSize } })
        .then((response) => {
          console.log(response.data.data, "then");
          setInterval(this.randerData(response), 1500);
        })
        .catch((error) => {
          if (error.response == undefined) {
            this.reviews = [];
          }
          console.log(error.response, "error");
          this.processing = false;
        });
    },
    truncateMessage(message, maxLength = 50) {
      if (message?.length > maxLength) {
        return message.substring(0, maxLength) + "...";
      }
      return message ?? 'N/A';
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(); 
},
    // async delete(id) {
    //   try {
    //     const {
    //       data: { status },
    //     } = await this.$axios.delete("location-type/" + id);
    //     this.responseDelete = status;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    // deleteLocationType(id) {
    //   Swal.fire({
    //     title: "Are you sure?",
    //     text: "You won't be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, delete it!",
    //   }).then(async (result) => {
    //     if (result.isConfirmed) {
    //       await this.delete(id);
    //       let status = this.responseDelete;
    //       if (status == true) {
    //         Swal.fire("Deleted!", "Record has been deleted.", "success");
    //         this.allLocationType({});
    //       }
    //     }
    //   });
    // },
    // locationTypeUpdate: function (id) {
    //   this.$router.push({
    //     name: "update-location-type",
    //     params: { id: id },
    //     query: { currentPage: this.currentPageNumber },
    //   });
    // },
    handleSearch(searchItem) {
      this.allReviews({ searchItem });
    },

    // selectAllRecord() {
    //   if (this.selectAll) {
    //     let ids = [];
    //     this.locationTypes.forEach((element) => {
    //       ids.push(element.id);
    //     });
    //     this.multipuleIds = [...new Set(ids)];
    //     console.log(this.multipuleIds);
    //   } else {
    //     this.multipuleIds = [];

    //     console.log(this.multipuleIds);
    //   }
    // },
    // deleteBulk() {
    //   this.$axios
    //     .post("location-type/bulk/delete/records", { ids: this.multipuleIds })
    //     .then((response) => {
    //       this.allLocationType({});
    //       this.triggerSwal(response.data.message, "success");
    //       this.selectAll = false;
    //       this.multipuleIds = [];
    //     })
    //     .catch((error) => {
    //       console.log(error.response);
    //     });
    // },
  },
};
</script>
<style scoped>
.review-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.review-column {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px;
  background-color: #fff;
}
.full-width {
  grid-column: span 2;
}
@media (max-width: 768px) {
  .review-info {
    grid-template-columns: 1fr;
  }
  .full-width {
    grid-column: span 1;
  }
}
.toolbar-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}

@media (max-width : 576px){
  .card-body{
    padding : 0.25rem !important;
  }
  .toolbar-row {
    justify-content: flex-start;
  }

  .toolbar-row:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons-container{
    width : 100%;
  }
}
@media (max-width: 768){
  .table > :not(caption) > * > *
  {
    padding: 0.25rem !important;
  }
}
</style>

